import React from 'react';
import DashboardPage from './DashboardPage';
import DashboardPageMobile from './DashboardPageMobile';

const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 768;
};

const DashboardPageWrapper: React.FC = () => {
  const [mobile, setMobile] = React.useState(isMobile());

  React.useEffect(() => {
    const handleResize = () => {
      setMobile(isMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mobile ? <DashboardPageMobile /> : <DashboardPage />;
};

export default DashboardPageWrapper; 